import React from 'react';
import './occasionType info.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,Image,TreeSelect } from "antd";
import { UploadOutlined } from '@ant-design/icons';
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
class occasionTypeInfo extends React.Component {
    state = {
        actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
        id:this.props.location.state.data.id,
        name_en:this.props.location.state.data.name_en,
        name_ar:this.props.location.state.data.name_ar,
        forGender:this.props.location.state.data.forGender?this.props.location.state.data.forGender:"BOTH",
        fromAge:this.props.location.state.data.fromAge,
        toAge:this.props.location.state.data.toAge,
        type:this.props.location.state.data.type?this.props.location.state.data.type:"OCCASION",
        occasionType:this.props.location.state.data,
        limit:this.props.location.state.data.limit?this.props.location.state.data.limit:1,
        selectedFile: null,
        img:this.props.location.state?this.props.location.state.data.img !== ""?this.props.location.state.data.img:null:null,
        imgType:'url',
        imgName:'',
        icon:this.props.location.state?this.props.location.state.data.icon !== ""?this.props.location.state.data.icon:null:null,
        iconType:'url',
        iconName:''
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
       
    }
    update = () => {
        const {name_en,name_ar,img,imgType,icon,iconType,type,forGender,fromAge,toAge} = this.state
        
        if(hasValue(name_en)&&hasValue(name_ar)){
            let l = message.loading('Wait..', 0.5)
            var data = new FormData()
            data.append('name_en',name_en)
            data.append('name_ar',name_ar)
            data.append('type',type)
            data.append('forGender',forGender)
            data.append('fromAge',fromAge)
            data.append('toAge',toAge)
            if(img != null && imgType === "data"){
                data.append('img',img)
            }
            if(icon != null && iconType === "data"){
                data.append('icon',icon)
            }
            
            console.log(Array.from(data))
            axios.put(`${BASE_END_POINT}occasion-suggestion/${this.props.location.state.data.id}`,data,{
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization':`Bearer ${this.props.currentUser.token}`,
                'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("occasionType UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }

    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}occasion-suggestion/${this.props.location.state.data.id}`,{
         headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
         },
        })
        .then(response=>{
          console.log("occasionType DELETED")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
        })
    }
   

    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.update()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    fileChangedHandler = event => {
        
        let theImg = event.target.files[0]
        this.setState({
            img:theImg,
            imgName: theImg.name,
            imgType:"data"
        })
        // let img = new Image()
        // img.src = window.URL.createObjectURL(event.target.files[0])
        // img.onload = () => {
        //     if(img.width !== img.height  || img.width > 1024 ||img.height > 1024){
        //         alert(allStrings.invalidImg);
        //     }else{
        //         this.setState({
        //             img:theImg,
        //             imgName: theImg.name,
        //             imgType:"data"
        //         })
        //        
        //     }
        // }
    }
    
    removeFile = () => {
      this.setState({
          img:null,
          imgName:'',
          imgType:"url"
      });
    }
    fileChangedHandlerIcon = event => {
        this.setState({
            icon:event.target.files[0],
            iconName: event.target.files[0].name,
            iconType:"data"
        })
    }
    
    removeFileIcon = () => {
        this.setState({
            icon:null,
            iconName:'',
            iconType:"url"
        });
    }
    imageSection = () =>{
          
        return(
          <MDBCol  xl ="4" lg = "5"  md="12" sm="12">
            <div className="infoCard">
                <div style={{width:"100%" ,padding:'10px'}}>
                    <Image
                    width="100%"
                    style={{borderRadius:'6px',width:"100%",height:'280px'}} 
                    src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.props.location.state.data.img}
                    />
                </div>
            </div>
            
        </MDBCol>
        )
    }
  
  render(){
    console.log(this.state.category)
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('OCCASION-TYPE')) return <Redirect to='/Home' />
  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol  xl={this.state.actionType==="VIEW"?"8":"12"} lg = {this.state.actionType==="VIEW"?"7":"12"} md="12" sm="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>star_outline</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{this.state.actionType ==="VIEW"?allStrings.info:allStrings.edit}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    {this.state.actionType ==="VIEW"&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishName}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name_en} type="text" id="form645" name="name_en" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicName}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name_ar} type="text" id="form56" name="name_ar" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                   <MDBRow>
                                        <MDBCol md="6" sm="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.forGender}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={false}
                                                disabled={this.state.actionType==="VIEW"?true:false}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.forGender}
                                                value={this.state.forGender}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({forGender:value});
                                                }} 
                                            >
                                                    <TreeNode value="MALE" title={allStrings.male} key="MALE" />
                                                    <TreeNode value="FEMALE" title={allStrings.female} key="FEMALE" />
                                                    <TreeNode value="BOTH" title={allStrings.both} key="BOTH" />
                                                
                                            </TreeSelect>
                                        </MDBCol>
                                        <MDBCol md="6" sm="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.type}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={false} 
                                                disabled={this.state.actionType==="VIEW"?true:false}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}         
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.type}
                                                value={this.state.type}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                console.log(value)
                                                this.setState({type:value});
                                                }} 
                                            
                                            >
                                                <TreeNode value="OCCASION" title={allStrings.occasion} key="OCCASION" />
                                                <TreeNode value="PERSONA" title={allStrings.persona} key="PERSONA" />
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.fromAge}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.fromAge} type="number" id="form645" name="fromAge" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.toAge}</label>
                                            <input  disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.toAge} type="number" id="form645" name="toAge" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    
                                    {this.state.actionType==="EDIT"&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2"> 
                                                <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                            </div>
                                            <div className="preview">
                                            {this.state.img&&
                                            <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                <img alt="" src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.state.img}  className="previewImg2"/>
                                                <span className="imgName">{this.state.imgName}</span>
                                                <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                onClick={() => this.removeFile()}  ></MDBIcon>
                                            </div>
                                            }
                                            </div>
                                            
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="EDIT"&&
                                        <MDBRow>
                                            <MDBCol md="12">
                                                <div className="fileUpload2"> 
                                                    <input  key={this.state.icon} type='file' className="upImgs2" onChange={this.fileChangedHandlerIcon} ></input>
                                                    <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.uploadIcon}</span></span>
                                                </div>
                                                <div className="preview">
                                                {this.state.icon&&
                                                    <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                        <img alt="" src={this.state.iconType==="data"?URL.createObjectURL(this.state.icon):this.state.icon}  className="previewImg2"/>
                                                        <span className="imgName">{this.state.iconName}</span>
                                                        <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                        onClick={() => this.removeFileIcon()}  ></MDBIcon>
                                                    </div>
                                                    }
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                    }
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                    {this.state.actionType==="EDIT"&&
                                        <MDBBtn
                                        style={{background:'#117183',color:'#fff'}}
                                        rounded
                                        color="#117183"
                                        type="submit"
                                        className="btn-block z-depth-1a"
                                        >
                                            <MDBIcon icon="edit" className="mr-2" />
                                            {allStrings.update}          
                                        </MDBBtn>
                                    }{this.state.actionType==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.delete()}} rounded color="danger" className="btn-block z-depth-1a">
                                            <MDBIcon icon="trash-alt" className="mr-2" />
                                            {allStrings.remove}
                                        </MDBBtn>
                                    }
                                        
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            {this.state.actionType==="VIEW"&&this.imageSection()}   
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(occasionTypeInfo)
  );